import React from "react";
import Form from "react-bootstrap/Form";
import "./slider.scss";

const Slider = (props) => {
  return (
    <div className={props.className}>
      <Form.Range
        className="range-slider"
        value={props.value}
        min={props.minValue}
        max={props.maxValue}
        step={props.step}
        onChange={props.onChange}
        disabled={props.disabled}
        aria-label="range selector"
      />
    </div>
  );
};

export default Slider;
